import(/* webpackMode: "eager", webpackExports: ["Home"] */ "/vercel/path0/frontend_next/src/screens/user/Home.tsx");
